import getCollection from '../support/getCollection'
import type { Entity, ListParams, ResourceType } from '../types'
import { useSyncedResourceList } from './useSyncedResourceList'

/**
 * Use a list of resources based on the parameters provided. Suspend until the API replies.
 */
export function useCollection<K extends ResourceType>(type: K, ...params: ListParams<K>): Entity<K>[] {
  const ids = getCollection(type, ...params).useKeys()
  return useSyncedResourceList(type, ids)
}

/**
 * Use a list of resources based on the parameters provided. Return null if not yet initialized.
 */
export function useNullableCollection<K extends ResourceType>(type: K, ...params: ListParams<K>): string[] | null {
  return getCollection(type, ...params).useKeysOrNull()
}
